import React from "react";
import AddCuentaGastoForm from "./AddCuentaGastoForm";

const AddCuentaGasto = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Gasto"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddCuentaGastoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddCuentaGasto;
